export default __webpack_public_path__ + "static/media/main_saying02_cn.cdae8309.png";